<template>
  <div class="content-table">
    <el-table :data="tableData" style="width: 100%;" row-key="id" default-expand-all stripe
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
      <el-table-column prop="name"
        :label="areaEnable === 1 ? $t('client.site.regionClient') : $t('client.site.client')">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('client.site.sites')" width="200">

        <template slot-scope="scope">
          <span>
            {{ scope.row.outletCount > 0 ? scope.row.outletCount : '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.action')" width="210">

        <template slot-scope="scope">
          <span class="txt txt-add" v-if="scope.row.type !== 'outlet'" @click.stop.prevent="clickAddIcon(scope.row)"
            v-permission="frameworkListAdd">{{ $t('common.create') }}</span>
          <span class="txt" @click.stop.prevent="clickTdDeviceListTxt(scope.row)" v-if="scope.row.type == 'outlet'"
            v-permission="deviceManage">{{ $t('client.site.devices') }}</span>
          <span class="txt txt-add" v-if="scope.row.level != 1" @click.stop.prevent="clickEditIcon(scope.row)"
            v-permission="frameworkListEdit">{{ $t('common.edit') }}</span>
          <span class="error-txt" @click="clickTdDelete(scope)" v-if="(scope.row.type == 'brand' && scope.row.level > 1)
      || (scope.row.type == 'outlet' && scope.row.deviceCount == 0)" v-permission="frameworkListDelete">{{
      $t('common.delete') }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  props: {
    tableData: [],
    currentBrandId: null,
  },
  data() {
    return {
      areaEnable: Number(Cookies.get("areaEnable")),
    }
  },
  methods: {
    clickAddIcon(row) {
      this.$emit('clickAddIcon', row)
    },
    clickTdDeviceListTxt(row) {
      this.$router.push({ name: 'deviceList', query: { brandId: this.currentBrandId, siteName: row.name } });
    },
    clickEditIcon(row) {
      this.$emit('clickEditIcon', row)
    },
    clickTdDelete(scope) {
      this.$emit('clickTdDelete', scope)
    },
  }
}

</script>

<style scoped lang="scss">
.content-table {
  .cell {
    line-height: 31px;
  }

  .txt {
    margin-right: 16px;
    color: $theme-color;
    cursor: pointer;
  }

  .txt-add {
    display: inline-block;
  }
}
</style>
